/**
 * This function fetch out the value of specific query string from the url.
 * @param {*Name of query string} name 
 * @param {*url from which you want to fetch the value of specific query string} url 
 */
export default function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    // eslint-disable-next-line
    name = name.replace(/[\[\]]/g, "\\$&");

    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}